import { styled } from '@mui/material'
import {
  toLabel as toWbsItemStatusLabel,
  WbsItemStatus,
} from '../../../domain/entity/WbsItemEntity'
import { intl } from '../../../i18n'
import Tooltip from '../../components/tooltips/Tooltip'
import { Text } from '../../components/typography'
import { colorPalette } from '../../style/colorPalette'
import { WbsItemStatusMarker } from '../WbsItemStatusChip'

const STATUS_MARKER_SIZE_PX = 12

type TicketListOptionProps = {
  displayName: string
  status: WbsItemStatus
}

// チケット管理表の選択肢1件。名前だけでは完了済みの管理表と現役のものが区別できないため、
// ステータスを丸印で併記する。統合チケット管理画面と単票画面の双方から使う。
export const TicketListOption = ({
  displayName,
  status,
}: TicketListOptionProps) => (
  // 丸印だけでは狙いにくいため、行全体をツールチップの対象にする。
  <Tooltip
    message={intl.formatMessage(
      { id: 'ticketList.select.optionTooltip' },
      { name: displayName, status: toWbsItemStatusLabel(status) ?? status }
    )}
  >
    <Root>
      <WbsItemStatusMarker
        status={status}
        size={STATUS_MARKER_SIZE_PX}
        colorVariant="chip"
        disableTitle={true}
      />
      <NameArea>
        <Text variant="m" color={colorPalette.monotone[4]}>
          {displayName}
        </Text>
      </NameArea>
    </Root>
  </Tooltip>
)

const Root = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  minWidth: 0,
})
// 名前が長くても他の要素を押し出さないよう、名前側だけを省略表示する
const NameArea = styled('div')({
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})
